import { ETypeTemplate, templateHeaderMapping } from "../models/upTemplate.model";

export const determinePropertyIdentifier = (header: any[]) => {
  //remover espacios en blanco and null
  const cleanHeader = header.filter(cell => cell !== null && cell !== "").join(",");
  if (cleanHeader === templateHeaderMapping.land) {
    return ETypeTemplate.land;
  } else if (cleanHeader === templateHeaderMapping.industrialSite) {
    return ETypeTemplate.industrialSite;
  } else if (cleanHeader === templateHeaderMapping.house) {
    return ETypeTemplate.house;
  } else if (cleanHeader === templateHeaderMapping.comercialLocals) {
    return ETypeTemplate.comercialLocals;
  } else if (cleanHeader === templateHeaderMapping.apartment) {
    return ETypeTemplate.apartment;
  } else {
    return ETypeTemplate.invalid;
  }
};
